import { env } from '@config/env';

/**
 * Structured logger. Verbose logs are stripped in production; warnings and
 * errors always surface. NEVER log tokens, passwords, or PII (standards §13.3).
 */
type LogContext = Record<string, unknown>;

export const logger = {
  debug(message: string, context?: LogContext): void {
    if (env.isDev) {
      // eslint-disable-next-line no-console
      console.debug(`[dda] ${message}`, context ?? '');
    }
  },
  info(message: string, context?: LogContext): void {
    if (env.isDev) {
      // eslint-disable-next-line no-console
      console.info(`[dda] ${message}`, context ?? '');
    }
  },
  warn(message: string, context?: LogContext): void {
    console.warn(`[dda] ${message}`, context ?? '');
  },
  error(message: string, context?: LogContext): void {
    console.error(`[dda] ${message}`, context ?? '');
  },
};
